import { Layout, Typography } from 'antd';
import { useEffect, useState } from 'react';
import moment from 'moment';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from 'hooks';
import { USER_NOTICE } from 'utils/constants';

import { FooterColumn } from './FooterColumn';
import { NoticeModal } from 'componets/ui';

import styles from './index.module.scss';
import {DarkModeSwitcher} from "../../../DarkModeProvider";

const SHOWED = 'showed';

export const Footer = () => {
	const [isNoticeOpen, setIsNoticeOpen] = useState(false);
	const menu = useAppSelector((state) => state.settings.menu);
	const location = useLocation();

	const { footer, user_notice } = menu;

	useEffect(() => {
		const isNotice =
			user_notice &&
			moment(user_notice.period * 1000).isAfter(moment()) &&
			Cookies.get(USER_NOTICE) !== SHOWED;
		if (isNotice) {
			setIsNoticeOpen(true);
		}
	}, [user_notice, location]);

	if (!footer?.contact) return null;

	return (
		<Layout.Footer className={styles.root}>
			<div className={styles.line} />

			<div className={styles.content}>
				<div className={`${styles.column} ${styles.columnLegal}`}>
					<FooterColumn {...footer.legal} />
					<div
						className={styles.legalInfo}
						dangerouslySetInnerHTML={{ __html: footer?.legal_info as any }}
					/>
				</div>

				<FooterColumn {...footer.about} />

				<FooterColumn {...footer.contact} />

				<div className={styles.column}>
					<Typography.Title level={5} className={styles.title}>
						{footer.applications?.title}
					</Typography.Title>
					<div className={styles.items}>
						{footer.applications?.content?.map((item) => (
							<a key={item.url} href={item.url} target="_blank" rel="noreferrer">
								<img src={item.icon} alt={item?.title} /> {item?.title}
							</a>
						))}
					</div>
					<DarkModeSwitcher />
				</div>

				<div className={`${styles.column} ${styles.columnSocials}`}>
					<div className={styles.socials}>
						<Typography.Title level={5} className={styles.title}>
							{footer.follow.title}
						</Typography.Title>

						<div className={styles.icons}>
							{footer.follow.content?.map((item) => (
								<a key={item.url} href={item.url} target="_blank" rel="noreferrer">
									<img src={item.icon} alt={item.url} />
								</a>
							))}
						</div>
					</div>

					<div className={styles.socials}>
						<Typography.Title level={5} className={styles.title}>
							{footer.community?.title}
						</Typography.Title>

						<div className={styles.icons}>
							{footer.community.content?.map((item) => (
								<a key={item.url} href={item.url} target="_blank" rel="noreferrer">
									<img src={item.icon} alt={item.url} />
								</a>
							))}
						</div>
					</div>
				</div>
			</div>

			<div className={styles.text} dangerouslySetInnerHTML={{ __html: footer.copyright }} />

			{isNoticeOpen && (
				<NoticeModal
					item={user_notice}
					isOpen={isNoticeOpen}
					onClose={() => {
						setIsNoticeOpen(false);
						Cookies.set(USER_NOTICE, SHOWED, { expires: new Date(user_notice?.period * 1000) });
					}}
				/>
			)}
		</Layout.Footer>
	);
};
